/**
 * 分码贴标编号：与 branch_pack_code（整单全局序号）一致。
 * 例：PG-202504-0001-0003 → PG-202504-0001-03
 */

export function branchLabelFromPackCode(packCode, dispatchOrderNo) {
  const pack = String(packCode || '').trim()
  if (!pack) return ''
  const m = pack.match(/-(\d+)$/)
  if (!m) return pack
  const seq = parseInt(m[1], 10)
  if (Number.isNaN(seq)) return pack
  const no = String(dispatchOrderNo || '').trim()
  const suffix = seq < 100 ? String(seq).padStart(2, '0') : String(seq)
  if (no) return `${no}-${suffix}`
  return pack
}

/** @param {object|null|undefined} row 分码行 */
export function displayedBranchLabel(row, dispatchOrderNo, fallbackIndex) {
  const fromPack = branchLabelFromPackCode(row?.branch_pack_code, dispatchOrderNo)
  if (fromPack) return fromPack
  const saved = String(row?.branch_label || '').trim()
  if (saved) return saved
  if (fallbackIndex != null) {
    const no = String(dispatchOrderNo || '').trim()
    const suffix = String(fallbackIndex + 1).padStart(2, '0')
    return no ? `${no}-${suffix}` : `--${suffix}`
  }
  return '—'
}
